import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import "./VendorOrdersScreen.css";
import logo from "../../Assets/logo.jpg";

const VendorOrdersScreen = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [expandedVendor, setExpandedVendor] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchVendorsWithOrders = async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get("/admin/vendors-with-orders");
      setVendors(data || []);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch vendors");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendorsWithOrders();
  }, []);

  const toggleExpand = (vendorId) => {
    setExpandedVendor(expandedVendor === vendorId ? null : vendorId);
  };

  // Filter vendors
  const filteredVendors = vendors.filter((vendor) => {
    const term = searchTerm.toLowerCase();
    return (
      vendor.name?.toLowerCase().includes(term) ||
      vendor.email?.toLowerCase().includes(term) ||
      vendor.contactNumber?.toLowerCase().includes(term)
    );
  });

  if (loading) return <div className="loading">Loading vendors...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="admin-vendor-orders-container">
      <h2>Vendor Orders Management</h2>

      {/* Search Bar */}
      <div className="search-bar-container">
        <input
          type="text"
          placeholder="🔍 Search by name, email, or contact..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Vendor Table */}
      <div className="table-wrapper">
        <table className="vendors-table">
          <thead>
            <tr>
              <th>Vendor</th>
              <th>Email</th>
              <th>Contact</th>
              <th>Wallet</th>
              <th>Total Orders</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredVendors.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No vendors found.
                </td>
              </tr>
            ) : (
              filteredVendors.map((vendor) => (
                <React.Fragment key={vendor._id}>
                  <tr className="vendor-row">
                    <td>
                      <div className="vendor-info">
                        <div className="vendor-avatar">
                          {vendor.name?.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <strong>{vendor.name}</strong>
                          <p className="business-name">
                            {vendor.businessName || "N/A"}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>{vendor.email || "N/A"}</td>
                    <td>{vendor.contactNumber || "N/A"}</td>
                  <td className="wallet-text">
  <div style={{ display: "flex", alignItems: "center" }}>
    <img
      src={logo}
      alt="currency"
      style={{
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        marginRight: "5px",
        objectFit: "cover",
        boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
      }}
    />
    <span>{(vendor.wallet ?? 0).toFixed(2)}</span>
  </div>
</td>

                    <td>{vendor.orders?.length || 0}</td>
                    <td>
                      <button
                        className="view-details-btn"
                        onClick={() => toggleExpand(vendor._id)}
                      >
                        {expandedVendor === vendor._id
                          ? "Hide Orders"
                          : "View Orders"}
                      </button>
                    </td>
                  </tr>

                  {/* Expanded Orders */}
                  {expandedVendor === vendor._id && (
                    <tr className="expanded-row">
                      <td colSpan="6">
                        {vendor.orders?.length === 0 ? (
                          <p className="no-orders-text">
                            No orders found for this vendor.
                          </p>
                        ) : (
                          <div className="orders-card">
                            <h3>Orders for {vendor.name}</h3>
                            <table className="orders-table">
                              <thead>
                                <tr>
                                  <th>Order ID</th>
                                  <th>Status</th>
                                  <th>Date</th>
                                  <th>User</th>
                                  <th>Item</th>
                                  <th>Qty</th>
                                  <th>Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                {vendor.orders.map((order) =>
                                  order.item ? (
                                    <tr key={order.orderId}>
                                      <td>{order.orderId || "N/A"}</td>
                                      <td>
                                        <span
                                          className={`status-badge ${
                                            order.status?.toLowerCase() || ""
                                          }`}
                                        >
                                          {order.status || "N/A"}
                                        </span>
                                      </td>
                                      <td>
                                        {order.createdAt
                                          ? new Date(
                                              order.createdAt
                                            ).toLocaleString()
                                          : "N/A"}
                                      </td>
                                      <td>
                                        <strong>{order.user?.name || "N/A"}</strong>
                                        <br />
                                        <small>
                                          {order.user?.email || order.user?.mobile || "N/A"}
                                        </small>
                                      </td>
                                      <td className="item-cell">
                                        <img
                                          src={
                                            order.item?.image?.url ||
                                            "/placeholder.png"
                                          }
                                          alt={order.item?.name || "Item"}
                                          className="item-image"
                                        />
                                        <span>{order.item?.name || "N/A"}</span>
                                      </td>
                                      <td>{order.item?.quantity ?? "N/A"}</td>
                                      <td>
  <div style={{ display: "flex", alignItems: "center" }}>
    <img
      src={logo}
      alt="currency"
      style={{
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        marginRight: "5px",
        objectFit: "cover",
        boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
      }}
    />
    <span>
      {order.item?.price !== undefined
        ? order.item.price.toFixed(2)
        : "0.00"}
    </span>
  </div>
</td>

                                    </tr>
                                  ) : null
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorOrdersScreen;
